import React, { useState, useEffect, useRef } from 'react';
import Preloader from '../src/components/Pre';
import Navbar from './components/Navbar';
import Home from './components/Home/Home';
import Footer from './components/Footer';
import Resume from './components/Resume/ResumeNew';
import { BrowserRouter as Router, Route, Routes, Navigate, useNavigate } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import CommandPalette from './components/CommandPalette';
import './style.css';
import './App.css';

const KONAMI = ['ArrowUp','ArrowUp','ArrowDown','ArrowDown','ArrowLeft','ArrowRight','ArrowLeft','ArrowRight','b','a'];
const THEMES = [
  { accent: '#0091ff', accent2: '#0055d4', accent3: '#00c2ff' },
  { accent: '#a259ff', accent2: '#7c2cf0', accent3: '#c77dff' },
  { accent: '#00d4aa', accent2: '#00a884', accent3: '#3dffc0' },
  { accent: '#ff6b6b', accent2: '#e63946', accent3: '#ff9192' },
  { accent: '#f5c842', accent2: '#e0a800', accent3: '#ffdb70' },
];

function App() {
  const [load, setLoad] = useState(true);
  const konamiIdx = useRef(0);
  const themeIdx = useRef(0);

  useEffect(() => {
    const timer = setTimeout(() => setLoad(false), 1200);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const onKey = e => {
      const key = e.key;
      if (key === KONAMI[konamiIdx.current]) {
        konamiIdx.current++;
        if (konamiIdx.current === KONAMI.length) {
          konamiIdx.current = 0;
          document.dispatchEvent(new CustomEvent('konami'));
        }
      } else {
        konamiIdx.current = key === KONAMI[0] ? 1 : 0;
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  useEffect(() => {
    const onKonami = () => {
      document.body.classList.add('konami-flash');
      setTimeout(() => document.body.classList.remove('konami-flash'), 1500);
    };
    const onCycleTheme = () => {
      themeIdx.current = (themeIdx.current + 1) % THEMES.length;
      const t = THEMES[themeIdx.current];
      const root = document.documentElement;
      root.style.setProperty('--accent', t.accent);
      root.style.setProperty('--accent2', t.accent2);
      root.style.setProperty('--accent3', t.accent3);
    };
    document.addEventListener('konami', onKonami);
    document.addEventListener('cycle-theme', onCycleTheme);
    return () => {
      document.removeEventListener('konami', onKonami);
      document.removeEventListener('cycle-theme', onCycleTheme);
    };
  }, []);

  return (
    <Router>
      <Preloader load={load} />
      <div className="App" id={load ? 'no-scroll' : 'scroll'}>
        <Navbar />
        <ScrollToTop />
        <AppRoutes />
      </div>
    </Router>
  );
}

function AppRoutes() {
  const navigate = useNavigate();
  return (
    <>
      <CommandPalette navigate={navigate} />
      <Routes>
        <Route path="/" element={<><Home /><Footer /></>} />
        <Route path="/resume" element={<Resume />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </>
  );
}

export default App;
